// extracted by mini-css-extract-plugin
export default {"digitalMenuContainer":"DigitalMenuLayoutContent_digitalMenuContainer__q1zXP"};